/** @format */

import {Box} from '@mui/material';
import {Trans} from 'react-i18next';

import {TOOLTIP_TEXTS} from '../Form/constants';
import FieldLabelWithHelp from '../Form/components/FieldLabelWithHelp';
import DigitField from '../Form/components/DigitField';
import {DigitFieldProps} from '../../types';

interface BudgetFieldProps {
  budget: string;
  onBudgetChange: DigitFieldProps['onChange'];
  disabled?: boolean;
}

const BudgetField = ({budget, onBudgetChange, disabled = false}: BudgetFieldProps) => {
  return (
    <Box>
      <FieldLabelWithHelp tooltipText={TOOLTIP_TEXTS.BUDGET}>
        <Trans>Общий бюджет</Trans>
      </FieldLabelWithHelp>
      <DigitField value={budget} onChange={onBudgetChange} symbol='₽' disabled={disabled} />
    </Box>
  );
};

export default BudgetField;
